module.exports = __webpack_public_path__ + "img/gotv.72d59400.png";